import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import React__default, { useState, useEffect, createContext, useContext } from 'react';
import { BsFolderPlus } from '@react-icons/all-files/bs/BsFolderPlus';
import { useContextSelector } from 'use-context-selector';
import { EditorPlaceholder } from '../../components/EditorPlaceholder/EditorPlaceholder.js';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import { EditorContext } from '../../contexts/internal/EditorContext.js';
import { createId } from '../../utils/createId.js';
import { findNode } from '../../utils/node.js';
import 'qs';
import 'query-string';

var TabContext = /*#__PURE__*/createContext({});
var useTabContext = function useTabContext() {
  return useContext(TabContext);
};
function Tab(_ref) {
  var children = _ref.children,
    path = _ref.path,
    buttonColumn = _ref.buttonColumn;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    id = _useState2[0],
    setId = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentIndex = _useState4[0],
    selectIndex = _useState4[1];
  useEffect(function () {
    setId(createId());
  }, []);
  useEditorInitializer({
    path: path,
    currentIndex: currentIndex,
    selectIndex: selectIndex
  });
  if (!children || !id) {
    return jsx(EditorPlaceholder, {
      icon: jsx(BsFolderPlus, null),
      message: "\uD0ED\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694."
    });
  }
  return jsx(TabContext.Provider, {
    value: {
      id: id,
      currentIndex: currentIndex,
      selectIndex: selectIndex
    }
  }, jsx(Buttons, {
    column: buttonColumn
  }, React__default.Children.map(children, function (child, index) {
    if (! /*#__PURE__*/React__default.isValidElement(child)) {
      return child;
    }
    return /*#__PURE__*/React__default.cloneElement(child, {
      index: index
    });
  })), jsx("div", {
    id: "tab-".concat(id, "-panel")
  }));
}
function useEditorInitializer(_ref2) {
  var path = _ref2.path,
    _ref2$currentIndex = _ref2.currentIndex,
    currentIndex = _ref2$currentIndex === void 0 ? -1 : _ref2$currentIndex,
    selectIndex = _ref2.selectIndex;
  var context = useContextSelector(EditorContext, function (context) {
    return context;
  });
  var node = context ? findNode(context.state.document, path) : undefined;
  function handleNodeDelete() {
    if (!context || !node) {
      return;
    }
    if (currentIndex < node.children.length) {
      return;
    }
    selectIndex === null || selectIndex === void 0 || selectIndex(0);
  }
  useEffect(handleNodeDelete, [node === null || node === void 0 ? void 0 : node.children.length]);
}
var Buttons = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e13j40uf0"
} : {
  target: "e13j40uf0",
  label: "Buttons"
})("display:flex;flex-wrap:wrap;width:100%;>*{", function (_ref3) {
  var column = _ref3.column;
  return "flex: 0 0 ".concat(100 / column, "%;");
}, " margin:0;border:0;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

export { Tab, useTabContext };
//# sourceMappingURL=Tab.js.map
